module.exports = __webpack_public_path__ + "static/media/ybi.429dbd40.jpg";